export const DocTemplateFolderTypeVals = {
    Section: 1,
    Tom: 2,
    Act: 4,
    ActDocumentSection: 5,
    ActDocument: 6,
    ActSection: 7,
    PaperSigningRoot: 8,

    isSection: (type) =>
        type === DocTemplateFolderTypeVals.Section ||
        type === DocTemplateFolderTypeVals.ActDocumentSection ||
        type === DocTemplateFolderTypeVals.ActSection
};
